/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Preset_Saved_ToastInputs */



/**
* | output |
* | --- |
* | "Preset saved successfully" |
*
* @param {Styles_Preset_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_preset_saved_toast = /** @type {((inputs?: Styles_Preset_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Preset_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Preset enregistre avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preimpostazione salvata correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительные настройки успешно сохранены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preajuste guardado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预设已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट सफलतापूर्वक सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinição salva com sucesso")
	return /** @type {LocalizedString} */ ("Preset saved successfully")
});